import { all, call, put, takeEvery } from "@redux-saga/core/effects";
import { AnyAction } from "redux";
import { COURSE_ENROLL } from "../actions/actions.constants";
import {
  courseEnrollError,
  courseEnrollLoading,
  courseEnrollSendData,
} from "../actions/enroll.action";
import { enroll } from "../apis/course.api";

function* courseEnroll(action: AnyAction): Generator<any> {
  yield put(courseEnrollError(""));
  try {
    const enrollResponse: any = yield call(enroll, action.payload);
    console.log("enrollResponse ", enrollResponse);
    yield put(courseEnrollSendData(enrollResponse.data));
    window.location.href = "/dashboard";
  } catch (error: any) {
    yield put(courseEnrollLoading(false));
    yield put(courseEnrollError(error.response.data.message));
  }
}

export function* watchEnrollCourse() {
  yield all([takeEvery(COURSE_ENROLL, courseEnroll)]);
}
